require('od-modules/handlers/dpresults/navigation_order').set(
    require('od-modules/config/desktop/navigation_desktop_order')
);
// widgets
require('./widgets/share_itinerary/main');
require('./widgets/browser_notification_popup/main');
require('./widgets/repricing_popup_manager/main');
require('./widgets/accommodation_search_manager');
require('./widgets/app_root');
require('./widgets/confirmation_manager');
require('./widgets/gdpr_newsletter/main');
require('./widgets/googleanalytics');
require('./widgets/dp_upsell_activation_rules_manager');
require('./widgets/flight_details');
require('./widgets/invoice_manager');
require('./widgets/paymentmanager.desktop');
require('./widgets/passengers_manager');
require('./widgets/promotionalcodes');
require('./widgets/shopping_cart_manager/shopping_cart_manager');
require('./widgets/trip_summary_price');
require('./widgets/special_request_manager');
require('./widgets/sessionrecorder');
require('./widgets/membership_subscription/membership_subscription');
require('./widgets/dp_waiting_page');
require('./widgets/dpsearchmanager');
require('./widgets/searchmanager');
Odigeo.defineWidget('dp_search_no_results', require('./widgets/dp_search_no_results'));
Odigeo.defineWidget('accommodation_details', require('./widgets/accommodation_details'));
require('./widgets/bin_detection_manager');
require('./widgets/baggage_summary/main');
require('./widgets/hand_baggage_summary/main');
require('./widgets/sidebar_summary');
require('./widgets/trip_summary_total_price/main');
require('./widgets/waiting_pages/main');
require('./widgets/security_cta_message/main');
require('./widgets/seatmap_desktop');
require('./widgets/seatmap_selection_manager');
require('./widgets/error_message_layer');
require('./widgets/paymenterrormanager');
require('./widgets/post_booking');
require('./widgets/post_booking_bags.desktop');
require('./widgets/post_booking_seats.desktop');
require('./widgets/post_booking_bin_detection');
require('./widgets/post_booking_accommodation');
require('./widgets/payment.desktop');
require('./widgets/persuasiveMessaging');
require('./widgets/collapsible_flight_summary/main.desktop');
require('./widgets/nagmanager/main');
require('./widgets/offline_sales_banner');
require('./widgets/country_links');
require('./widgets/service_options_table');
require('./widgets/meta_traffic_co_search');
require('./widgets/passengers_update');
require('./widgets/searchsummary');
require('./widgets/onelinesearchmanager');
require('./widgets/oneline_cabinclass');
require('./widgets/passengers_search_manager');
require('./widgets/direct_flight_search_manager');
require('./widgets/direct_flights_search_manager');
require('./widgets/flexible_dates_search_manager');
require('./widgets/onelinebutton_search_manager');
require('./widgets/flight_type_search_manager');
require('./widgets/itinerary_search_manager');
require('./widgets/itinerary_manager/itinerary_md_search_manager');
require('./widgets/book_flight_manager');
require('./widgets/details_manager');
require('./widgets/pricemanager_enhanced');
require('./widgets/share_selection');
require('./widgets/seats_left_on_top');
require('./widgets/ancillaries_module/ancillaries_module.desktop');
require('./widgets/ancillaries_debuginfo/ancillaries_debuginfo');
require('./widgets/smart_nag_baggage');
require('./widgets/boarding_options/main.desktop');
require('./widgets/progress_bar/main');
require('./widgets/search_combine_message/main');
require('./widgets/fare_upgrade_c4ar/main');
require('./widgets/membership_prices_tracker/membership_prices_tracker');

// components
require('components/jsConfig/desktop.secure.js');

// handlers - order matters
require('./apps/desktop.handler.details');
require('./apps/desktop.handler.payment');
require('./apps/desktop.handler.pbpayment');
require('./apps/desktop.handler.payment3ds');
require('./apps/desktop.handler.confirmation');
require('./apps/desktop.handler.register');
require('./apps/desktop.handler.resetpassword');
require('./apps/desktop.handler.accountblocked');
require('./apps/desktop.handler.frequentpassengers');
require('./apps/desktop.handler.accountcreditcards');
require('./apps/desktop.handler.accountpreferences');
require('./apps/desktop.handler.mytrips');
require('./apps/desktop.handler.support_center');
require('./apps/desktop.handler.loginexpired');
require('./apps/desktop.handler.mytripslogin');
require('./apps/desktop.handler.post_booking');
require('./apps/desktop.handler.attachment');
require('./apps/desktop.handler.primepostbooking');
require('./apps/desktop.handler.membership_password_setup');
require('./apps/desktop.handler.membership_onboarding');
require('./apps/desktop.handler.membership_renewal_reactivation');
require('./apps/desktop.handler.tripdetails');
require('./apps/desktop.handler.tripdetails_booking_management');
require('./apps/desktop.handler.unavailablecheckin');
require('./apps/desktop.handler.metaancillaries');
require('./apps/handler.dpredirect')(require('od-modules/config/desktop/dpredirect.mapped_routes'));
require('od-modules/frontend-shell/base-integration');
require('./apps/desktop');

